module.exports = __webpack_public_path__ + "static/media/10.80aae488.png";